import axios from "axios";
import importExportTest from "./Editor/importExportTest";
import { logging } from "./tools";
import eventBus from "./eventBus";

const api = axios.create({
  baseURL: window.REACT_APP_CONTROLLER_PATH,
  /*   headers: {
    "Content-Type": "application/json",
  }, */
});

// log all outgoing and incomming trafic
const servicesLogging = ({ url, res, data }) => {
  if (
    ["/getLocalInteraction.php", "/getPublicInteraction.php"].includes(url) &&
    window?.DEBUG
  ) {
    importExportTest(res.data);
  }
  if (!res.data?.status) {
    // check if status key does not exist
    logging(`Unknown status from ${url} (more details below)`);
    logging("Input:");
    logging({ url, params: data });
    logging("Output:");
    logging(Object.values(res.data).join(""));
    return;
  }
  // don't log the login
  if (url !== window.REACT_APP_LOGIN_ADDRESS)
    logging({ ...res.data, url, params: data });
};

// called when an error occured
const errorFunc = (error) => {
  const errorMessage =
    error?.response?.headers?.["custom-message"] ?? "Unknown error";
  eventBus.emit("error", error?.response?.status ?? -1);
  throw error;
};

const checkStatus = (data) => {
  if (data?.status === -1) eventBus.emit("error", -1);
};

// don't throw error when fetch was not successful
const fetchData = (url, data) =>
  api.get(url, data).then((res) => {
    return res.data;
  });

// status !== -1 and throw error when fetch wasn't successful
const getData = (url, data = {}) =>
  api
    .post(url, data)
    .then((res) => {
      servicesLogging({ url, data, res });
      checkStatus(res.data);
      return res.data;
    })
    .catch(errorFunc);

// status !== -1 and throw error when fetch wasn't succesful
const postData = (url, data) =>
  api
    .post(url, data)
    .then((res) => {
      servicesLogging({ url, data, res });
      checkStatus(res.data);
      return res;
    })
    .catch(errorFunc);

export const getClients = ({ projectId, sessionId }) =>
  getData("/getClients.php", { projectId, sessionId });

export const postSearchClient = ({
  q,
  s,
  newOnly,
  archived,
  projectId,
  sessionId,
}) =>
  postData("/getClients.php", {
    q,
    s,
    newOnly,
    archived,
    projectId,
    sessionId,
  });

export const getTimeline = ({ clientId, projectId, sessionId }) =>
  getData("/getTimeLine.php", { id: clientId, projectId, sessionId });

export const getBeeps = ({ clientId, beepIdList, projectId, sessionId }) =>
  getData("/getBeeps.php", { id: clientId, beepIdList, projectId, sessionId });

export const getLocalMoodboard = ({ clientId, projectId, sessionId }) =>
  getData("/getLocalMoodBoard.php", { id: clientId, projectId, sessionId });

export const getLocalInteractions = ({ clientId, projectId, sessionId }) =>
  getData("/getLocalInteractions.php", { id: clientId, projectId, sessionId });

export const getBeepSchedule = ({ clientId, projectId, sessionId }) =>
  getData("/getBeepSchedule.php", { id: clientId, projectId, sessionId });

export const postBeepSchedule = ({
  clientId,
  beepSchedule,
  projectId,
  sessionId,
}) =>
  postData("/saveBeepSchedule.php", {
    id: clientId,
    beepSchedule: JSON.stringify(beepSchedule),
    projectId,
    sessionId,
  });

export const postLocalMoodboard = ({
  clientId,
  moodBoardJSON,
  projectId,
  sessionId,
}) =>
  postData("/saveLocalMoodBoard.php", {
    id: clientId,
    moodBoardJSON,
    projectId,
    sessionId,
  });

export const getLocalInteraction = ({
  clientId,
  interactionId,
  projectId,
  sessionId,
}) =>
  getData("/getLocalInteraction.php", {
    id: clientId,
    interactionId,
    projectId,
    sessionId,
  });
export const getLocalInteractionList = ({
  clientId,
  interactionIdList,
  projectId,
  sessionId,
}) =>
  getData("/getLocalInteraction.php", {
    id: clientId,
    interactionIdList,
    projectId,
    sessionId,
  });
export const postLocalInteraction = ({
  clientId,
  interactionId,
  interactionJSON,
  install = 0,
  projectId,
  sessionId,
}) =>
  postData("/saveLocalInteraction.php", {
    id: clientId,
    interactionId,
    interactionJSON,
    install,
    projectId,
    sessionId,
  });

export const postPreviewInteraction = ({
  connectionId,
  questionList,
  useAsButton,
  buttonText,
  buttonLabel,
  singleUse,
  questionListName,
  projectId,
  sessionId,
}) =>
  postData("/doQuestionnaireTest_link.php", {
    connectionId,
    questionList,
    useAsButton,
    buttonText,
    buttonLabel,
    singleUse,
    questionListName,
    projectId,
    sessionId,
  });

export const getTags = ({ projectId, sessionId }) =>
  getData("/getTags.php", { projectId, sessionId });
export const postSearchLibrary = ({
  q,
  t,
  a,
  start = 0,
  length = 20,
  contextId,
  projectId,
  sessionId,
}) =>
  postData("/searchLibrary.php", {
    q,
    t: JSON.stringify(t),
    a,
    start,
    length,
    contextId,
    projectId,
    sessionId,
  });

export const poll = ({ id, projectId, sessionId }) =>
  getData("/poll.php", { id, projectId, sessionId });

export const getPublicInteraction = ({ interactionId, projectId, sessionId }) =>
  getData("/getPublicInteraction.php", { interactionId, projectId, sessionId });

export const getUserSettings = ({ projectId, sessionId }) =>
  getData("/getUserSettings.php", { projectId, sessionId });

export const postRequestPasswordReset = ({ email, sessionId }) =>
  postData(window.REACT_APP_REQUEST_NEW_PASS_ADDRESS, {
    email,
    sessionId,
  });

export const postUserSettings = (data) =>
  postData("/saveUserSettings.php", data);

export const postStatus = ({ clientId, status, projectId, sessionId }) =>
  postData("/setStatus.php", { id: clientId, status, projectId, sessionId });

export const postInitials = ({ clientId, initials, projectId, sessionId }) =>
  postData("/saveInitials.php", {
    id: clientId,
    initials,
    projectId,
    sessionId,
  });

export const postPublicInteraction = ({
  interactionId,
  interactionJSON,
  name,
  description,
  _public,
  projectId,
  sessionId,
}) =>
  postData("/savePublicInteraction.php", {
    interactionId,
    interactionJSON,
    name,
    description,
    public: _public,
    projectId,
    sessionId,
  });

export const postLogin = (data) =>
  postData(window.REACT_APP_LOGIN_ADDRESS, data);

export const postTestDevice = ({ clientId, projectId, sessionId }) =>
  postData("/setTestDevice.php", { id: clientId, projectId, sessionId });

export const getActiveContexts = ({ projectId, sessionId }) =>
  getData("/getActiveContexts.php", { projectId, sessionId });

export const addContext = ({ invitationCode, projectId, sessionId }) =>
  postData("/addContext.php", { invitationCode, projectId, sessionId });

export const sharePublicInteraction = (
  { id, publicStatus, projectId, sessionId } // pass the contextId to the server
) =>
  postData("/setPublicInteractionStatus.php", {
    id,
    publicStatus,
    projectId,
    sessionId,
  });

export const setContextStatus = (
  { id, left, projectId, sessionId } // pass NOT the contextId to the server
) => postData("/setContextStatus.php", { id, left, projectId, sessionId });

export const getPublicMoodboards = ({ projectId, sessionId }) =>
  getData("/getPublicMoodBoards.php", { projectId, sessionId });

export const getPublicMoodboard = ({ id, projectId, sessionId }) =>
  postData("/getPublicMoodBoard.php", { id, projectId, sessionId });

export const postPublicMoodboard = ({
  id,
  moodBoardJSON,
  name,
  projectId,
  sessionId,
}) =>
  postData("/savePublicMoodBoard.php", {
    id,
    moodBoardJSON,
    name,
    projectId,
    sessionId,
  });

export const getSettings = ({ clientId, projectId, sessionId }) =>
  postData("/getSettings.php", { id: clientId, projectId, sessionId });

export const postSettings = ({ id, settingsJSON, sessionId, projectId }) =>
  postData("/saveSettings.php", { id, settingsJSON, sessionId, projectId });

export const getNotes = ({ clientId, projectId, sessionId }) =>
  postData("/getNotes.php", { id: clientId, projectId, sessionId });

export const saveNotes = ({ clientId, notesJSON, projectId, sessionId }) =>
  postData("/saveNotes.php", { id: clientId, notesJSON, projectId, sessionId });

export const installCounter = ({
  clientId,
  buttonText,
  buttonLabel,
  projectId,
  sessionId,
}) =>
  postData("/installCounter.php", {
    id: clientId,
    buttonText,
    buttonLabel,
    projectId,
    sessionId,
  });

export const getProjects = ({ sessionId }) =>
  getData("/getProjects.php", { sessionId });

export const postProtocol = ({
  clientId,
  protocolId,
  lastSaved,
  protocolLastSaved,
  changesJSON,
  projectId,
  sessionId,
  dateOffset,
  timeShift,
}) =>
  postData("/applyProtocol.php", {
    id: clientId,
    protocolId,
    lastSaved,
    protocolLastSaved,
    changesJSON,
    projectId,
    sessionId,
    dateOffset,
    timeShift,
  });

export const postLock = ({ clientId, sessionId }) =>
  postData("/requestLock.php", { id: clientId, sessionId });

export const unlockAll = ({ sessionId }) =>
  postData("/unlockAll.php", { sessionId });

export const requestUnlock = ({ clientId, sessionId }) =>
  postData("/requestUnlock.php", { id: clientId, sessionId });

export const postError = ({ clientId, sessionId, errorMessage, stack, code }) =>
  postData("/logError.php", {
    id: clientId,
    sessionId,
    errorMessage,
    stack,
    code,
  });

export const getErrorMessages = ({ sessionId }) =>
  fetchData(window.REACT_APP_ERROR_MESSAGES_ADDRESS, {
    sessionId,
  });
